import { cn } from '@/lib/utils';
import * as React from 'react';

export const formatTelValue = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  if (digits.length > 10) return '';

  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const Input = ({ className, onChange, type, ...props }: React.ComponentProps<'input'>): React.JSX.Element => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (type === 'tel') {
      const formattedValue = formatTelValue(e.target.value);

      if (formattedValue !== e.target.value) {
        const nextEvent = {
          ...e,
          currentTarget: {
            ...e.currentTarget,
            value: formattedValue,
          },
          target: {
            ...e.target,
            value: formattedValue,
          },
        } as React.ChangeEvent<HTMLInputElement>;

        onChange?.(nextEvent);
        return;
      }
    }
    onChange?.(e);
  };

  return (
    <div className={cn(
      'group relative flex items-center rounded-sm border bg-white transition-[color,border-color,box-shadow]',
      'ring-2 ring-offset-0 shadow-xs',
      'focus-within:!ring-black focus-within:!bg-white focus-within:border-black',
      props['aria-invalid']
        ? 'border-primary ring-primary bg-[var(--input-error-background)]'
        : 'border-input ring-transparent',
      className
    )}
    >
      <input className={cn(
        'file:text-foreground placeholder:text-muted-foreground bg-transparent transition-[color]',
        'border-none flex-1 min-w-0 !ps-2 !pe-2 p-2 text-base outline-none',
        'pl-3',
        'pr-3',
        'focus-visible:outline-none focus:outline-none'
      )}
      data-slot="input"
      type={type}
      {...props}
      onChange={handleChange}
      />
    </div>
  );
};

export { Input };
